import http from "@/http";
// 白名单
// 查询
export const getCurrent = {
  p: "/v1/current/index",
  r: data => {
    return http({
      url: "/v1/current/index",
      method: "post",
      data
    });
  }
};
// 删除
export const deleteCurrent = {
  p: "/v1/current/delete",
  r: data => {
    return http({
      url: "/v1/current/delete",
      method: "post",
      data
    });
  }
};
// 修改
export const editCurrent = {
  p: "/v1/current/edit",
  r: data => {
    return http({
      url: "/v1/current/edit",
      method: "post",
      data
    });
  }
};
// 添加
export const addCurrent = {
  p: "/v1/current/add",
  r: data => {
    return http({
      url: "/v1/current/add",
      method: "post",
      data
    });
  }
};

// export const addCurrent = data => {
//   return http({
//     url: "/v1/current/add",
//     method: "post",
//     data
//   });
// };
